import { useEffect, useState } from 'react';
import { createLazyObjectUrls, type LazyObjectUrls } from '../utils/lazyObjectUrls';

type ObjectUrlGetter = (id: string) => Promise<string>;

// The registry is made in the effect and handed out through state, so StrictMode's re-run never
// leaves a consumer holding a disposed one; null until the first one exists.
export function useLazyObjectUrls(load: (id: string) => Promise<Blob>): ObjectUrlGetter | null {
    const [urls, setUrls] = useState<LazyObjectUrls | null>(null);

    useEffect(() => {
        const registry = createLazyObjectUrls(load);
        setUrls(registry);
        return () => registry.dispose();
    }, [load]);

    return urls?.get ?? null;
}
